import * as React from 'react';

function SvgPinterestColour(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="PinterestColour_svg__a"
        maskUnits="userSpaceOnUse"
        x={2}
        y={2}
        width={26}
        height={27}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 2.219h25.819v25.818H2V2.219z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#PinterestColour_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.819 15.127c0 7.131-5.78 12.91-12.91 12.91S2 22.258 2 15.127C2 7.997 7.78 2.22 14.909 2.22c7.13 0 12.91 5.778 12.91 12.908z"
          fill="#BC081C"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.473 21.163c1.068 1.225 2.843 1.685 4.399 1.209.321-.098.64-.213.949-.346a5.9 5.9 0 001.652-1.044c1.387-1.265 2.141-2.858 2.492-4.668.455-2.353.042-4.547-1.445-6.434-.903-1.146-2.178-1.899-3.54-2.374-1.847-.645-3.922-.722-5.79-.12a8.541 8.541 0 00-1.562.685c-1.749.994-3.095 2.595-3.644 4.54a9.137 9.137 0 00-.285 1.596c-.125 1.297.161 2.582.75 3.737.094.183.211.35.299.536.208.439.523.875.91 1.171.179.139.4.26.634.244.326-.023.407-.335.497-.604.098-.298.132-.612.197-.917.058-.278.066-.445-.107-.692-1.37-1.947-.9-5.099.79-6.677 1.53-1.429 3.268-1.847 5.213-1.571 1.733.246 3.28 1.383 3.957 3.016.277.67.367 1.578.376 2.29a7.018 7.018 0 01-.545 2.901c-.339.82-.85 1.612-1.565 2.153-1.052.794-3.262 1.138-3.708-.515a3.188 3.188 0 01-.04-1.347c.208-1.038.606-2.024.845-3.052.126-.549.211-1.1.06-1.66-.175-.659-.585-1.085-1.27-1.178-.73-.1-1.413.127-1.836.694-.884 1.183-.996 2.535-.563 3.928.092.3.126.557.05.869-.418 1.69-.78 3.394-1.215 5.078a11.726 11.726 0 00-.34 3.5c.016.328.023.658.098.978.05.215.129.521.34.634.291.154.538-.218.675-.42.54-.797.963-1.687 1.282-2.595.208-.59.37-1.193.527-1.799.056-.212.363-1.31.463-1.745z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgPinterestColour;
